import { Component, Input } from "@angular/core";
import { DocumentModel } from "@models/documents/documentmodel";
import { TranslocoPipe } from "@jsverse/transloco";
import { DateTimeFormatPipe } from "@app/shared/pipes/date-time-format.pipe";

@Component({
    selector: "eff-document-details",
    templateUrl: "./eff-document-details.component.html",
    styleUrls: ["./eff-document-details.component.scss"],
    imports: [TranslocoPipe, DateTimeFormatPipe]
})
export class EffDocumentDetailsComponent {
    @Input() document: DocumentModel;
}
